module.exports = __webpack_public_path__ + "static/media/auditorium.70717a74.jpg";